module.exports = "/images/chevron-right-pink.svg?bdc2b52d52b154312ec904ae4ea03953";